<div class="spinner">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
    <circle class="background" cx="14" cy="14" r="12"></circle>
    <circle class="foreground" cx="14" cy="14" r="12"></circle>
  </svg>
</div>
<ng-content></ng-content>
